/**
Copyright (C) 2019-2022, Infraclear Inc. All Rights Reserved.
*/

import { Button, CircularProgress, Dialog, Divider, IconButton } from '@mui/material';
import React, { useState } from 'react';
import './uploadUsersPopUp.scss'
import CloseIcon from '@mui/icons-material/Close';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import { DownloadUserCSV, UploadUserCSV } from '../../constants/api-urlConstants';
import instance from '../../utils/axiosInstance';
import axios from 'axios';
import { MessageText } from '../../constants/messageText';
import { SnackBarMessage } from '../snackBar/snackBar';
import { apiBasePath } from '../../constants/env-url';
import { TimerValusSet } from '../../context/TimerContext';

export const UploadUsersPopUp: React.FC<any> = (props: any) => {

  const { setUserHeartBeat, timeExit } = React.useContext(TimerValusSet);
  const [openPopUp, setOpenPopUp] = React.useState(props.openModel);
  const [statusIsLoading, setStatusIsLoading] = useState(false);
  const [msgConfig, setMsgConfig] = useState({
    type: '',
    message: '',
    snackFlag: false
  })
  const [file, setFile] = useState<any>({});

  const handleCancel = () => {
    setOpenPopUp(false);
    props.closeConfirmation(false);
  };

  const handleOnChange = (event: any) => {
    setFile(event.target.files[0]);
  };

  const handleOnSubmit = () => {
    setStatusIsLoading(true)
    const payload = {
      'file': file
    };
    const BASE_PATH_URL = `${apiBasePath}${UploadUserCSV}`;
    const config = { headers: { 'Content-Type': 'multipart/form-data' }, withCredentials: true };
    axios.post(BASE_PATH_URL, payload, config)
      .then((response: any) => {
        setUserHeartBeat(timeExit());
        setStatusIsLoading(false);
        if (response.data.message_code === 'INVALID_FILE') {
          setMsgConfig({
            type: 'error',
            message: MessageText.INVALIDFILE,
            snackFlag: true
          })
        }
        else {
          props.closeConfirmation(true);
        }
      })
      .catch((errors) => {
        setStatusIsLoading(false)
        setMsgConfig({
          type: 'error',
          message: MessageText.WENT_WRONG,
          snackFlag: true
        })
      });
  };

  const downloadCSV = () => {
    const BASE_PATH_URL = `${DownloadUserCSV}`;
    instance
      .get(BASE_PATH_URL)
      .then((response) => {
        setUserHeartBeat(timeExit());
        window.open(`data:text/csv;charset=utf-8,${response.data}`, '_blank')
      })
      .catch((error) => {
        setMsgConfig({
          type: 'error',
          message: MessageText.WENT_WRONG,
          snackFlag: true
        })
      })
  }

  return (
    <>
      {msgConfig.snackFlag && <div>
        <SnackBarMessage snacBarValue={msgConfig}
        />
      </div>}
      <div >
        <Dialog
          open={openPopUp}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <div className='usersPopup' >
            <div className="downloadUsertextWrapper">
              <span className="titleTextConfirm">
                Upload bulk user
              </span>
              <div className='closeIconWrapper'>
                <IconButton
                  aria-label="close"
                  onClick={handleCancel}
                  sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                  }}
                >
                  <CloseIcon />
                </IconButton>
              </div>
            </div >
            <Divider />
            <div className='dialogContentWtapper'>
              <div className="descWrapper">
                <Button variant="contained" component="label" >
                  Select file
                  <input hidden accept=".csv/*" multiple type="file" onChange={handleOnChange} />
                </Button >
                <IconButton color="primary" aria-label="upload picture" component="label">
                  <input hidden accept=".csv/*" type="file" />
                </IconButton>
              </div>
              <div className='downloadFile'>
                <IconButton color="primary" aria-label="add to shopping cart" className='downloadButton' onClick={downloadCSV} >
                  <CloudDownloadIcon />
                  <span style={{ paddingLeft: '5px' }}>
                    Download sample csv
                  </span>
                </IconButton>
              </div>
            </div>
            <div className="userpopupActions">
              <div className="popupActionsWrapper">
                <Button className='secondaryBtn'
                  onClick={handleCancel} style={{ textTransform: "none" }}
                >
                  Cancel
                </Button>
                {statusIsLoading && <div className="loader">
                  <CircularProgress size={25}
                  />
                </div>
                }
                {!statusIsLoading &&
                  <Button variant="contained" onClick={handleOnSubmit} type="submit" style={{ textTransform: "none", width: '45%' }} disabled={file.name !== undefined ? false : true}>
                    Upload
                  </Button>
                }
              </div>
            </div>
          </div>
        </Dialog>
      </div>
    </>
  )
}